import { useState, useEffect } from 'react';

const DEFAULT_HTML = `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"><title>預覽</title></head>
<body>
  <h1>Hello World</h1>
  <p>編輯左側 HTML 即時預覽。</p>
</body>
</html>`;

/**
 * HTML 可視化網頁：輸入 HTML 即時在 iframe 預覽
 */
export function HtmlPreviewTool() {
  const [html, setHtml] = useState(DEFAULT_HTML);
  const [previewKey, setPreviewKey] = useState(0);

  const runPreview = () => setPreviewKey(k => k + 1);

  useEffect(() => {
    const t = setInterval(runPreview, 800);
    return () => clearInterval(t);
  }, [runPreview]);

  const iframeSrc = `data:text/html;charset=utf-8,${encodeURIComponent(html)}`;

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <div className="mb-2 flex items-center justify-between">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
            HTML 原始碼
          </label>
          <button
            type="button"
            onClick={runPreview}
            className="rounded bg-primary px-3 py-1.5 text-sm text-white hover:bg-primary/90"
          >
            重新載入預覽
          </button>
        </div>
        <textarea
          value={html}
          onChange={e => setHtml(e.target.value)}
          placeholder="輸入 HTML..."
          rows={12}
          className="w-full rounded border border-gray-300 bg-white px-3 py-2 font-mono text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
          aria-label="HTML 原始碼"
          spellCheck={false}
        />
      </div>

      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          預覽
        </h2>
        <div className="min-h-[320px] overflow-auto rounded border border-gray-200 bg-white dark:border-gray-600">
          <iframe
            key={previewKey}
            title="HTML 預覽"
            src={iframeSrc}
            sandbox="allow-scripts"
            className="h-[400px] w-full border-0"
          />
        </div>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          輸入完整 HTML（可含 &lt;style&gt;、&lt;script&gt;），即時在下方 iframe
          預覽。預覽在沙箱中執行，僅供前端除錯使用。
        </p>
      </section>
    </>
  );
}
